import * as React from 'react';

function SvgCzechRepublic(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 35 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#fff" d="M0 0h35v11H0z" />
      <path fill="#D7151A" d="M0 11h35v10.5H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0l18 11L0 21V0z"
        fill="#10457E"
      />
    </svg>
  );
}

export default SvgCzechRepublic;
